import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	createGlobalField: {
		id: 'polaris-ideas.right-sidebar.fields.footer.create-global-field',
		defaultMessage: 'Create a global field',
		description: 'Link button that takes the user to the global field page',
	},
});
